document.addEventListener('ShoptetDOMCartContentLoaded', function() { 
    $('.cart-widget-product').each(function(){
        $(this).find('.cart-widget-product-name').append('<span class="amountProduct">'+$(this).find('.cart-widget-product-amount input.amount').val()+' '+$(this).find('.cart-widget-product-unit').text()+'</span>')
    })

})

if($('.id--16, .id--17').length){
    $.get('/action/Cart/GetCartContent/?orderingProcessActive=1', function(data){   
        $('.cart-item[data-micro="cartItem"]').each(function(){
            get_id = $(this).attr('data-micro-sku')
            link = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image a').attr('href')
            image = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image img').attr('data-src').replace('related', 'detail')
            if(!$(this).find('.right').length){
                $(this).wrapInner('<div class="right"></div>')
                $(this).prepend('<div class="image"><a href="'+link+'"><img src="'+image+'" alt="'+$(this).find('a[data-testid="recapItemName"]').text()+'"></a></div>')
            }
        })
    })
    $('.cart-inner').prepend($('.cart-header'))
}

if($('.id--9').length){
    function mhProductInfoMove(){
        $('.cart-table tr').each(function(){
          var findcenazakus = $(this).find('.p-price.p-cell').html();
          var findptotal = $(this).find('.p-total');
          $(this).find('.p-name').append('<div class="avail">'+$(this).find('.p-availability').html()+'</div>')
          $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
        })
    };
    mhProductInfoMove()
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        mhProductInfoMove();
    });
}

if($('.id--16').length){
    $('.co-box').each(function() {
  if ($(this).text().includes('Táto kombinácia dopravy a platby nie je možná.')) {
    $(this).html($(this).html().replace(
      'Táto kombinácia dopravy a platby nie je možná.',
      cartText
    ));
  }
});
}